import React from 'react';

export const EmptyStorageTable = () => {
  return (
    <div className="flex justify-center py-24 text-moon-500">
      This directory doesn’t have any files. Add some and you’ll see them here.
    </div>
  );
};
